import type { OrganisationId } from "../types/organisation.js";
import { THALAMOS_ORGANISATION_ID } from "../types/thalamos.js";

/**
 * Whether an organisation's kind, organisation relationships and user
 * memberships may be changed: every organisation but the Thalamos
 * organisation, whose user memberships follow the directory group rather than
 * anybody's decision.
 */
export const isOrganisationChangeable = (
  organisationId: OrganisationId,
): boolean => organisationId !== THALAMOS_ORGANISATION_ID;
